import React, { HTMLAttributes } from "react";
import StyledTable from "./Table.styled";
import TableHead from "../../molecules/TableHead";
import TableRow from "../../molecules/TableRow";

export interface ITable extends HTMLAttributes<HTMLTableElement> {
  /** Set card content text alignment */
  fullWidth?: boolean;
  /** Set the inner padding inside the Card */
  width?: number;
  values?: Array<any>;
  data: Array<any>;
  spacing?: number;
  tableHeadline?: string;
  noDataMessage?: string;
}

const Table = ({
  fullWidth,
  tableHeadline,
  width,
  spacing,
  values,
  data,
  noDataMessage,
}: ITable) => (
  <StyledTable fullWidth={fullWidth} width={width} spacing={spacing}>
    {tableHeadline && (
      <TableHead values={[{ label: tableHeadline, colspan: 100 }]} />
    )}
    {values && <TableHead values={values} />}
    {data.length ? (
      data.map((row) => <TableRow values={row} />)
    ) : (
      <TableRow
        values={[{ label: noDataMessage || "No data available", colspan: 100 }]}
      />
    )}
  </StyledTable>
);

export default Table;
